import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { NbMenuService, NbMenuItem } from '@nebular/theme';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DropdownMenuItem } from '../../models/button.interface';

@Component({
    selector: 'pv-dropdown-action-button',
    templateUrl: './dropdown-action-button.component.html',
    styleUrls: ['./dropdown-action-button.component.scss'],
    standalone: false
})
export class DropdownActionButtonComponent implements OnInit, OnDestroy {
  @Input() label?: string;
  @Input() icon?: string;
  @Input() disabled: boolean = false;
  @Input() size: 'tiny' | 'small' | 'medium' | 'large' | 'giant' = 'small';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() loading: boolean = false;
  @Input() menuItems: DropdownMenuItem[] = [];
  @Input() contextMenuTag: string = 'dropdown-action-menu';
  
  @Output() menuItemClick = new EventEmitter<DropdownMenuItem>();

  public contextMenuItems: NbMenuItem[] = [];
  private destroy$ = new Subject<void>();

  constructor(private nbMenuService: NbMenuService) {}

  ngOnInit() {
    this.initializeMenuItems();
    this.subscribeToMenuClicks();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get hasIcon(): boolean {
    return !!this.icon;
  }

  get hasLabel(): boolean {
    return !!this.label;
  }

  onClick(event: Event): void {
    if (this.disabled || this.loading) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  private initializeMenuItems() {
    this.contextMenuItems = this.menuItems.map(item => ({
      title: item.title,
      icon: item.icon,
      disabled: item.disabled,
      data: { originalItem: item }
    }));
  }

  private subscribeToMenuClicks() {
    this.nbMenuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        if (this.isTargetMenuEvent(event)) {
          this.menuItemClick.emit(event.item.data.originalItem);
        }
      });
  }

  private isTargetMenuEvent(event: any): boolean {
    return event.tag === this.contextMenuTag && event.item.data?.originalItem;
  }
}
